<template>
  <div class="pageStyle">
    <div class="rightBg">
      <div class="rightBg-box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="title">
      <div>您好！</div>
      <div>{{ welcomeTxt }}</div>
    </div>
    <div class="content">
      <van-tabs v-model="active">
        <van-tab title="密码登录">
          <div class="input">
            <div class="item">
              <span class="item-title">手机号</span>
              <!-- <van-field
                type="digit"
                v-model="form.username"
                placeholder="请输入您的手机号码"
              /> -->
              <van-field
                v-model="form.username"
                placeholder="请输入您的手机号码"
              />
            </div>
            <div class="item">
              <span class="item-title">密码</span>
              <van-field
                type="password"
                v-model="form.password"
                placeholder="请输入您的密码"
              />
            </div>
          </div>

          <!-- <div class="check">
            <van-checkbox
              icon-size="4vw"
              v-model="form.checked"
              shape="square"
              checked-color="#0b6ff9"
              >我已阅读并同意<span> 隐私政策 </span>和<span> 注册协议</span>
            </van-checkbox>
          </div> -->
        </van-tab>
        <van-tab title="验证码登录"
          ><div class="input">
            <div class="item">
              <span class="item-title">手机号</span>
              <van-field
                type="digit"
                v-model="form.username"
                placeholder="请输入您的手机号码"
              />
            </div>
            <div class="item code">
              <span class="item-title">验证码</span>
              <van-field
                maxlength="6"
                v-model="form.code"
                placeholder="请输入验证码"
              >
                <template #button>
                  <van-button
                    size="small"
                    type="primary"
                    color="#0b6ff9"
                    @click="toGetCode"
                    >{{ codeTxt }}</van-button
                  >
                </template>
              </van-field>
            </div>
          </div>

          <!-- <div class="check">
            <van-checkbox
              icon-size="4vw"
              v-model="form.checked"
              shape="square"
              checked-color="#0b6ff9"
              >我已阅读并同意<span> 隐私政策 </span>和<span> 注册协议</span>
            </van-checkbox>
          </div> -->
        </van-tab>
      </van-tabs>
      <div class="btn">
        <span @click="toSubmit">登录</span>
      </div>
      <div class="fun">
        <span class="blueColor" @click="toPage('')">返回首页</span>
        <span
          >还没有账号？<s class="blueColor" @click="toPage('sign')">立即注册</s>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Tab,
  Tabs,
  Field,
  Checkbox,
  Button,
  Notify,
  Dialog,
  Toast,
} from "vant";
import {
  xcChannelLogin,
  loginBySms,
  sendSms,
  isSign,
  updateChannelToken,
} from "@/api/login.js";
import { xcDepConfig } from "@/api/depConfig.js";
import { setToken } from "@/utils/auth.js";
import { getToken } from "@/utils/auth.js";
import { getDepNameByDomain, getWxUserInfo } from "@/utils/index";
import { mapGetters } from "vuex";
import store from "@/store";
import Cookies from "js-cookie";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(Button);
export default {
  data() {
    return {
      active: 0,
      form: {
        username: "",
        code: "",
        password: "",
        depName: "",
      },
      title: "",
      codeTxt: "发送验证码",
      getCodeFlag: false,
      welcomeTxt: "",
      redirectUrl: this.$route.query.redirectUrl,
    };
  },
  computed: {
    ...mapGetters(["Login"]),
  },
  mounted() {
    this.form.depName = getDepNameByDomain();
    console.log("this.depName", this.form.depName);
    xcDepConfig(this.form.depName).then((res) => {
      if (res.depName === "csqfpt" || res.depName === "jf") {
        this.welcomeTxt = "欢迎来到湖南社会组织金融赋能平台";
      } else if (res.depName === "hntyjrpt") {
        this.welcomeTxt = "欢迎来到湖南退役军人服务平台";
      } else {
        this.welcomeTxt = "欢迎来到" + res.depTitle;
      }
    });
    this.form.openId = getWxUserInfo() ? getWxUserInfo().openid : "";
  },

  methods: {
    toPage(name) {
      if (name === "sign") {
        // 判断是否携带注册后的回调地址参数
        if (this.redirectUrl) {
          this.$router.push({
            path: "/sign",
            query: { redirectUrl: this.redirectUrl },
          });
        } else {
          this.$router.push({ path: "/sign" });
        }
      } else {
        this.$router.push({ path: "/" + name });
      }
    },
    toSubmit() {
      if (this.toVerify()) {
        Toast.loading({
          message: "登陆中...",
          forbidClick: true,
          duration: 0,
        });

        // 密码登录
        if (this.active === 0) {
          xcChannelLogin(this.form)
            .then((res) => {
              console.log("res", res);
              Toast.clear();
              setToken(res.token);
              this.setChannelToken(res.token);
              store.dispatch("Login", res.user);
              Notify({ type: "success", message: "登录成功" });
              // 判断是否有回调地址
              if (this.redirectUrl) {
                this.$router.push({
                  path: "/",
                  query: { redirectUrl: this.redirectUrl },
                });
              } else {
                // 没有回调地址,跳转首页
                this.$router.push({ path: "/" });
              }
            })
            .catch((err) => {
              Toast.clear();
            });
        }
        // 手机号验证码登录
        else {
          loginBySms(this.form)
            .then((res) => {
              Toast.clear();
              setToken(res.token);
              this.setChannelToken(res.token);
              store.dispatch("Login", res.user);
              Notify({ type: "success", message: "登录成功" });
              // 判断是否有回调地址
              if (this.redirectUrl) {
                this.$router.push({
                  path: "/",
                  query: { redirectUrl: this.redirectUrl },
                });
              } else {
                // 没有回调地址,跳转首页
                this.$router.push({ path: "/" });
              }
            })
            .catch((err) => {
              Toast.clear();
            });
        }
      }
    },
    toGetCode() {
      // 防止频繁点击
      if (this.getCodeFlag) return false;
      if (!this.form.username) {
        Notify({ type: "danger", message: "请输入您的手机号" });
        return false;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 判断用户是否存在
      isSign(this.form.username)
        .then((res) => {
          // 已存在 发送验证码
          if (res === true) {
            sendSms(this.form.username)
              .then((res) => {
                Toast.clear();
                Notify({
                  type: "success",
                  message: "验证码已发送，请留意您的手机短信",
                });
                this.phoneCodeInterval();
              })
              .catch((err) => {
                Toast.clear();
                Notify({ type: "danger", message: "验证码发送失败" });
              });
          }
          // 如果用户不存在 不发送验证码 提示注册
          else {
            Toast.clear();
            Dialog.confirm({
              title: "提示",
              message: "该账号未注册，是否去注册",
              confirmButtonText: "去注册",
            })
              .then(() => {
                this.toPage("sign");
              })
              .catch(() => {});
          }
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    phoneCodeInterval() {
      let time = 60;
      this.getCodeFlag = true;
      let v = setInterval(() => {
        time = time - 1;
        this.codeTxt = time + " s " + "重新获取";
        if (time == 0) {
          clearInterval(v);
          this.getCodeFlag = false;
          this.codeTxt = "获取验证码";
        }
      }, 1000);
    },
    toVerify() {
      // 手机号密码登录
      if (this.active === 0) {
        if (!this.form.username) {
          Notify({ type: "danger", message: "请输入您的手机号" });
          return false;
        }
        if (!this.form.password) {
          Notify({ type: "danger", message: "请输入您的密码" });
          return false;
        }
        return true;
      }
      // 手机号验证码登录
      else {
        if (!this.form.username) {
          Notify({ type: "danger", message: "请输入您的手机号" });
          return false;
        }
        if (!this.form.code) {
          Notify({ type: "danger", message: "请输入验证码" });
          return false;
        }
        return true;
      }
    },
    // 设置渠道的token
    setChannelToken(token) {
      let body = {
        token: token,
      };
      updateChannelToken(body).then((res) => {
        console.log("res", res);
      });
    },
  },
};
</script>
<style scoped>
.pageStyle {
  height: 100%;
  position: relative;
  padding: 16vw 10vw 10vw 10vw;
}
.title {
  display: grid;
  gap: 2vw;
  /* color: white; */
}
.title div:nth-of-type(1) {
  font-weight: 600;
  font-size: 9vw;
}
.title div:nth-of-type(2) {
  /* font-weight: 600; */
  font-size: 6vw;
}
.content {
  margin-top: 10vw;
  /* padding: 6vw 0; */
}
.content /deep/ .van-tabs .van-tab .van-tab__text {
  font-size: 4.6vw;
  font-weight: 600;
  /* color: #000000; */
}
.content /deep/ .van-tabs .van-tab {
  flex: none;
  padding: 0;
}
.content /deep/ .van-tabs .van-tabs__nav {
  gap: 6vw;
}
.content /deep/ .van-tabs .van-tab--active {
  color: #0b6ff9;
}
.content /deep/ .van-tabs .van-tabs__line {
  background-color: #0b6ff9;
  width: 18vw;
}
.content .item /deep/ .van-field__body {
  display: flex;
  align-items: center;
  height: 34px;
}
.input {
  display: grid;
  gap: 6vw;
  padding-top: 6vw;
}
.input .item {
  border-bottom: 1px solid #dde0e2;
}
.input .item .item-title {
  display: block;
  font-weight: 600;
  color: #97a3b1;
  font-size: 4vw;
}
.input .item .van-field {
  padding: 2vw 0 2vw 0;
}
.input .item /deep/ .van-cell input {
  font-weight: 600;
  font-size: 4vw;
}
.input .item /deep/ .van-cell input::placeholder {
  color: #4f5f70;
  font-weight: 600;
  font-size: 4vw;
}

.btn {
  padding-top: 6vw;
  font-size: 4vw;
}
.btn span {
  display: block;
  height: 100%;
  border-radius: 8px;
  background-color: #0b6ff9;
  color: white;
  text-align: center;
  font-weight: 600;
  padding: 4vw 0;
}
.fun {
  display: flex;
  justify-content: space-between;
  padding-top: 6vw;
  font-weight: 600;
  font-size: 4vw;
}
.fun span {
  /* font-size: 3.6vw; */
}
.fun .blueColor {
  text-decoration: none;
  color: #0b6ff9;
}
.rightBg {
  position: absolute;
  top: 0;
  right: 0;
}
.rightBg .rightBg-box {
  position: relative;
}
.rightBg .rightBg-box div {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 0 0 100%;
}
.rightBg .rightBg-box div:nth-of-type(1) {
  background-color: #1e56d1;
  width: 20vw;
  height: 20vw;
}
.rightBg .rightBg-box div:nth-of-type(2) {
  background-color: #1e56d1;
  width: 25vw;
  height: 25vw;
  opacity: 0.6;
}
.rightBg .rightBg-box div:nth-of-type(3) {
  background-color: #1e56d1;
  width: 30vw;
  height: 30vw;
  opacity: 0.4;
}
.rightBg .rightBg-box div:nth-of-type(4) {
  background-color: #1e56d1;
  width: 35vw;
  height: 35vw;
  opacity: 0.2;
}

/* .check {
  margin-top: 6vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.check /deep/ .van-checkbox .van-checkbox__label {
  color: #9da6b1;
  font-weight: 600;
  font-size: 3.6vw;
}
.check /deep/ .van-checkbox {
  align-items: inherit;
}
.check span {
  color: #0b6ff9;
  font-size: 3.6vw;
}
.check /deep/ .van-checkbox .van-icon {
  border-radius: 4px;
}
.check /deep/ .van-checkbox .van-checkbox__icon {
  margin-bottom: 1px;
} */
</style>



// WEBPACK FOOTER //
// src/view/login/index.vue